export default {"src":"/_next/static/media/user.58fb149f.svg","height":40,"width":34,"blurWidth":0,"blurHeight":0};